exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-687d51f4] .el-tabs__content{height:calc(100% - 55px);overflow-y:auto}", ""]);

// exports
